module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.10a60d8.woff2";